@defer (on viewport({ rootMargin: '300px' }); when isEager() || isCached(); prefetch on immediate) {
  <img
    class="picture {{ size() }} bg-{{ background() }}"
    [class.no-rounding]="roundedBorder() === false"
    [src]="(image$ | async) || userPlaceholder"
    [alt]="gid()" />
} @placeholder {
  <img
    class="picture {{ size() }} bg-{{ background() }}"
    [class.no-rounding]="roundedBorder() === false"
    [src]="userPlaceholder"
    [alt]="gid()" />
}
